import * as React from 'react'
import { theme } from '../theme'

export type GenerationType = 'landingPage' | 'referenceImage' | 'prompt'

interface Props {
    value: GenerationType
    onChange: (type: GenerationType) => void
}

export const GenerationTypeSelector = ({
    value = 'landingPage',
    onChange
}: Props) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: theme.spacing.sm,
                padding: theme.spacing.sm,
                backgroundColor: theme.colors.surface,
                borderRadius: theme.borderRadius.sm,
            }}
        >
            <label
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: theme.spacing.sm,
                    cursor: 'pointer',
                    fontSize: '12px',
                    color: value === 'landingPage' ? theme.colors.primary : theme.colors.text.primary,
                    padding: theme.spacing.xs,
                    borderRadius: theme.borderRadius.sm,
                    backgroundColor: value === 'landingPage' ? 'rgba(47, 123, 118, 0.1)' : 'transparent',
                    transition: 'all 0.2s ease',
                }}
            >
                <input
                    type="radio"
                    name="generationType"
                    checked={value === 'landingPage'}
                    onChange={() => onChange('landingPage')}
                    style={{
                        cursor: 'pointer',
                        width: '16px',
                        height: '16px',
                        accentColor: theme.colors.primary,
                    }}
                />
                Generate based on landing page
            </label>
            <label
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: theme.spacing.sm,
                    cursor: 'pointer',
                    fontSize: '12px',
                    color: value === 'referenceImage' ? theme.colors.primary : theme.colors.text.primary,
                    padding: theme.spacing.xs,
                    borderRadius: theme.borderRadius.sm,
                    backgroundColor: value === 'referenceImage' ? 'rgba(47, 123, 118, 0.1)' : 'transparent',
                    transition: 'all 0.2s ease',
                }}
            >
                <input
                    type="radio"
                    name="generationType"
                    checked={value === 'referenceImage'}
                    onChange={() => onChange('referenceImage')}
                    style={{
                        cursor: 'pointer',
                        width: '16px',
                        height: '16px',
                        accentColor: theme.colors.primary,
                    }}
                />
                Generate based on reference image
            </label>
            <label
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: theme.spacing.sm,
                    cursor: 'pointer',
                    fontSize: '12px',
                    color: value === 'prompt' ? theme.colors.primary : theme.colors.text.primary,
                    padding: theme.spacing.xs,
                    borderRadius: theme.borderRadius.sm,
                    backgroundColor: value === 'prompt' ? 'rgba(47, 123, 118, 0.1)' : 'transparent',
                    transition: 'all 0.2s ease',
                }}
            >
                <input
                    type="radio"
                    name="generationType"
                    checked={value === 'prompt'}
                    onChange={() => onChange('prompt')}
                    style={{
                        cursor: 'pointer',
                        width: '16px',
                        height: '16px',
                        accentColor: theme.colors.primary,
                    }}
                />
                Generate based on prompt
            </label>
        </div>
    )
}
